export enum signupTypes {
  FETCH_SIGNUP_REQUEST = "FETCH_SIGNUP_REQUEST",
  FETCH_SIGNUP_SUCCESS = "FETCH_SIGNUP_SUCCESS",
  FETCH_SIGNUP_FAILURE = "FETCH_SIGNUP_FAILURE",
}